import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React from "react";

export default function IncludeExcludeToggleButton({
    includeOrExclude,
    setIncludeOrExclude,
    onChange,
}: {
    includeOrExclude: string,
    setIncludeOrExclude: any,
    onChange?: (value: string) => void
}) {

    const handleAlignment = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string | null,
    ) => {
        if (newAlignment === null) return;
        setIncludeOrExclude(newAlignment);
        if (onChange) {
            onChange(newAlignment);
        }
    };

    return (
        <ToggleButtonGroup
            style={{ marginTop: "10px", marginLeft: "4px", marginRight: "4px", width: "100%" }}
            value={includeOrExclude}
            exclusive
            onChange={(event, newAlignment) => {
                handleAlignment(event, newAlignment);
            }}
            aria-label="include or exclude"
            size='small'
        >
            <ToggleButton style={{
                padding: '4px 8px',
                width: '48%',
                textTransform: 'none'
            }} value="include" aria-label="left aligned">
                Include
            </ToggleButton>
            <ToggleButton style={{
                padding: '4px 8px',
                width: '48%',
                textTransform: 'none'
            }} value="exclude" aria-label="exclude">
                Exclude
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
